var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoinvestors = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 70,
  height: 70
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "silver",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 49.396,
  cy: 50.842,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "m53.396 46.842-8 8M45.396 46.842l8 8M39.312 62.645c-2.163.124-4.474.197-6.915.197-10.136 0-17.733-1.186-21.979-2.066-1.861-.386-2.456-2.746-1.002-3.971 2.911-2.452 7.08-4.436 12.873-5.428.979-.167 2.357-2.619 1.525-5.398M27.272 32.042h.199M37.277 32.042h.2M24.898 30.842h4.874M39.923 30.842h-4.875M44.343 36.245c1.971-1.069 2.403-4.484 2.403-6.213 0-1.136-.98-1.881-1.47-2.375.12-.648.828-.148.828-.148.112-.621.792-1.208 1.042-3.417.665-5.875-2.874-10.129-7.688-11.839-1.933-.687-9.955-2.076-12.944-4.971-1.082-1.048-.341 4.854-1.32 5.295-5.125 2.304-8.798 5.932-7.256 12.307.201.835.875.917 1.571 2.773-.489.493-1.47 1.238-1.47 2.375 0 1.729.439 5.227 2.403 6.213.178 3.8 3.371 9.733 3.371 9.733 3.471 3.139 5.943 4.507 7.246 4.507.057 0 .62-.331 1.496-.331.601 0 1.075.146 1.342.244"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.803 26.155c-.042-1.875 1.377-1.954 3.677-3.104 2.25-1.125 3.616-2.879 6.48-3.208-2.23 1.792-2 4.75-1.125 6.25 6.33-4.788 10.558-.001 15.603-1.792 1.291-.458 3.166.25 3.041 2.25M34.489 56.082c-.642.102-1.315.158-2.02.158-5.365 0-9.289-3.375-9.715-4.898M34.397 42.842s-.688.301-2 .301-2-.301-2-.301"
}))));
export default SvgNoinvestors;